if (!customElements.get('nosto-bundle-upsell')) {
  customElements.define(
    'nosto-bundle-upsell',
    class NostoBundleUpsell extends window.BAO.CustomElement() {
      requiredEls = ['content', 'items', 'submit', 'close', 'title']

      connectedCallback () {
        this.closedUpsellModal = false
        this.excludedHandles = []

        this.waitForNosto()
      }

      waitForNosto () {
        const observerConfig = {
          childList: true,
          subtree: true,
        }

        const mutationObserver = new MutationObserver(
          this.handleMutation.bind(this),
        )

        mutationObserver.observe(this, observerConfig)
      }

      handleMutation (mutationsList, observer) {
        mutationsList.forEach(mutation => {
          if (mutation.type === 'childList') {
            const injection = this.querySelector(
              '[data-nosto-bundle-upsell-el="nostoInjection"]',
            )

            if (!injection) return

            if (injection) {
              this.titleCheck()
              this.buildHandles()
              this.setupListeners()
              observer.disconnect()
            }
          }
        })
      }

      titleCheck () {
        const nostoTitle = this.querySelector(
          '.sec-Section_NostoVertical-title',
        )
        if (nostoTitle) {
          const replaceTitle = this.querySelector(
            '[data-nosto-bundle-upsell-el="title"]',
          )
          if (replaceTitle) replaceTitle.innerText = nostoTitle.innerText
        }
      }

      buildHandles () {
        const excluded = this.excludedHandles || []

        excluded.push({
          id: this.dataset.productId,
          handle: this.dataset.productHandle,
        })

        const urls = JSON.parse(
          this.querySelector('[data-nosto-bundle-upsell-el="nostoInjection"]')
            .textContent,
        )

        const dataToConstructHTML = urls
          .map(url => {
            if (excluded.find(u => u.handle === this.extractHandle(url))) {
              return false
            } else {
              return {
                nostoUrl: url,
                shopifyHandle: this.extractHandle(url),
              }
            }
          })
          .filter(item => typeof item === 'object' && item !== null)

        this.clear()

        this.fetchAllBundleLists(dataToConstructHTML)
      }

      async fetchAllBundleLists (dataToConstructHTML) {
        const fetchPromises = dataToConstructHTML.map(data =>
          this.createBundleList(data),
        )
        const htmlList = await Promise.all(fetchPromises)

        htmlList.forEach(html => {
          this.renderBundleUpsell(html)
        })

        this.show()
      }

      async createBundleList (data) {
        let html = await this.fetchSectionHTML(data)
        html = this.swapHrefWithNostoUrl(html, data.nostoUrl)
        return html
      }

      swapHrefWithNostoUrl (html, url) {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = html

        const aTag = tempDiv.querySelector('a')

        if (aTag) {
          aTag.href = url.replace(/&amp;/g, '&')
        }

        return tempDiv.innerHTML
      }

      setupListeners () {
        super.setupListeners()

        this.onAfterCartAdd = this.onAfterCartAdd.bind(this)
        this.onAfterRemove = this.onAfterRemove.bind(this)

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
          this.onAfterCartAdd,
        )

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_REMOVE_ITEM,
          this.onAfterRemove,
        )
      }

      async onAfterRemove (event) {
        const variantIdOfRemovedItem =
          event.detail?.state?.items_removed[0]?.variant_id

        this.excludedHandles = this.excludedHandles.filter(
          item => item.id !== variantIdOfRemovedItem,
        )
        this.buildHandles()
      }

      async onAfterCartAdd (event) {
        const handleOfAddedProduct = event.detail?.form?.dataset?.productHandle
        const idOfAddedProduct = event.detail?.item?.id

        this.excludedHandles.push({
          id: idOfAddedProduct,
          handle: handleOfAddedProduct,
        })
        this.buildHandles()
      }

      async fetchSectionHTML (data) {
        return await fetch(
          `/products/${data.shopifyHandle}?section_id=${this.sectionId}`,
        )
          .then(response => response.text())
          .then(responseText => {
            const innerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('#shopify-section-async-bundle-item').innerHTML
            return innerHTML
          })
      }

      renderBundleUpsell (html) {
        if (this.hasEl('content')) {
          this.els.list.element.insertAdjacentHTML('beforeEnd', html)
        }
      }

      clear () {
        this.els.list.element.innerHTML = ''
      }

      show () {
        this.setAttribute('aria-hidden', false)
      }

      hide () {
        this.setAttribute('aria-hidden', true)
      }

      hasEl (elementName) {
        return this.els[elementName] && this.els[elementName].exists
      }

      disconnectedCallback () {
        super.disconnectedCallback()

        window.localStorage.removeItem(this.storageName)
      }

      get upsellAddedToCart () {
        return window.localStorage.getItem(this.storageName) === 'true'
      }

      get storageName () {
        return `BAO-upsell-used-${this.productId}`
      }

      get sectionId () {
        return 'async-bundle-item'
      }

      get productHandle () {
        return this.dataset.productHandle
      }

      get productId () {
        return this.dataset.productId
      }

      extractHandle (url) {
        const pathname = new URL(url).pathname
        const productHandle = pathname.split('/').pop()

        return productHandle
      }
    },
  )
}
